import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';

@observer
class Image extends Component {
    @observable src = this.props.src;

    componentWillUpdate(nextProps) {
        if (nextProps.src !== this.props.src) {
            this.setSrc(nextProps.src);
        }
    }

    @action onError = () => {
        this.src = this.props.defaultImage;
    };

    @action setSrc = (src) => {
        this.src = src;
    };

    render() {
        const {className, alt, style, defaultImage} = this.props;
        return (
            <img src={this.src || defaultImage} onError={this.onError} className={className} alt={alt} style={style}/>
        );
    }
}

Image.propTypes = {
    src: PropTypes.string,
    defaultImage: PropTypes.string,
    className: PropTypes.string,
    alt: PropTypes.string,
    style: PropTypes.object
};
export default Image;
